module.exports = __webpack_public_path__ + "prod/1.42.2/img/api-five.8ca72f8f.png";